import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
  } from "@mui/material";
  
  export default function ProductDetails({ row }) {
    return (
      <Box sx={{ minWidth: "900px", maxWidth: 1000 }}>
        <TableContainer>
          <Table size="small">
            <TableHead
              sx={{
                "& tr th": {
                  background: (theme) => theme.palette.primary.lighter,
                  paddingLeft: "8px",
                  color: (theme) => theme.palette.primary.darker,
                },
              }}
            >
              <TableRow>
                <TableCell>Product Name</TableCell>
                <TableCell>ISBN</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Single Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {row.items?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Typography variant="subtitle2">
                      {item.productName}
                    </Typography>
                  </TableCell>
                  <TableCell>{item.isbn || "-"}</TableCell>
                  <TableCell>{item.qty}</TableCell>
                  <TableCell>{item.price}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
  